<template>
    <inter-table
        :showFilters="true"
        :fields="fields"
        action="matches"
        :filters="filters"
    >
        <template v-slot:cell(opponent)="data">
            <div class="d-flex align-items-center">
                <div class="media" style="width: 80px">
                    <img :src="matchLogo(data.item.competizione)" class="img-thumbnail" alt="logo"/>
                </div>
                <div class="flex-grow-1 ml-2">
                    <div class="text-uppercase text-primary bold">
                        {{ data.item.opponent }} <small>{{ data.item.competizione }}</small>
                    </div>
                    <div class="small"><span class="">DATA: </span> {{ data.item.date | date }}</div>
                    <div class="small"><span class="">IMPORTO: </span> {{ data.item.price | currency }}</div>
                    <div class="small"><span class="">RATIO: </span> 1 : {{ data.item.adult_vs_childs }}</div>
                </div>
            </div>

        </template>

        <template v-slot:cell(sectors)="data">
            <div class="d-flex small justify-content-between">
                <div class="mx-1 flex-grow-1"
                     v-for="(sector, index) in data.item.sectors" v-bind:key="index">
                    <b-card no-body>
                        <b-card-header class="p-1 text-center">{{ sector.code }}</b-card-header>
                        <div class="p-1 text-center">{{ sector.availability }}</div>
                    </b-card>
                </div>
            </div>
        </template>

        <template v-slot:cell(interval)="data">
            <div class="mb-2">
                <span class="text-success">{{ data.item.start_request | date }}</span>
            </div>
            <div>
                <span class="text-danger">{{ data.item.end_request | date }}</span>
            </div>
        </template>

        <template v-slot:cell(requests)="data">
            <div v-if="data.item.requests.length">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="mx-1 flex-grow-1" v-for="(status, index) in requestStatuses" v-bind:key="index">
                        <b-card no-body
                                :border-variant="status.variant">
                            <b-card-header :header-bg-variant="status.variant" class="p-1 text-center text-white">
                                <i class="fi small" v-bind:class="status.icon"></i>
                            </b-card-header>
                            <div class="p-1 text-center small">{{ getStatusQuantity(data.item.requests, index) }}</div>
                        </b-card>
                    </div>
                </div>
            </div>
            <div v-else>
                <small class="text-primary">Nessuna richiesta</small>
            </div>
        </template>

        <template v-slot:cell(action)="data">
            <div class="d-flex justify-content-end">
                <inter-table-button
                    icon="flaticon-open-folder"
                    @onClick="$emit('onShow', data.item)"
                >
                </inter-table-button>
            </div>
        </template>
        <template slot="custom-filters">
            <b-col cols="12" md="6" class="mb-3">
                <inter-select
                    placeholder="Partita"
                    v-model="filters.match"
                    asyncFindAction="select/matches"
                    :archive="false"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
                <inter-input
                    placeholder="Da"
                    v-model="filters.start_date"
                    type="date-autocomplete"
                    icon="calendar">
                </inter-input>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
                <inter-input
                    placeholder="A"
                    v-model="filters.end_date"
                    type="date-autocomplete"
                    icon="calendar">
                </inter-input>
            </b-col>

            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                    placeholder="stato"
                    v-model="filters.status"
                    :option-selected="filters.status"
                    :options="statusOptions"
                ></inter-select>
            </b-col>

        </template>
    </inter-table>
</template>

<script>
import InterTable from "../../../components/table/InterTable";
import InterTableButton from "../../../components/table/InterTableButton";
import _ from "lodash";
import Utils from '@/utils'
import InterSelect from "../../../components/form/inter-select/InterSelect.vue";
import InterInput from "../../../components/form/inter-input/InterInput.vue";
import MatchService from "@/services/match-service";

export default {
    name: "AdminMatchesTable",
    components: {InterInput, InterSelect, InterTableButton, InterTable},
    data() {
        return {
            requestStatuses: Utils.getRequestStatuses(),
            filters: {
                match: null,
                start_date: null,
                end_date: null,
                status: "progress",
            },
            fields: [
                {key: 'opponent', label: 'Avversario', class: 'text-left'},
                {key: 'sectors', label: 'Settori', class: 'text-center'},
                {key: 'interval', label: 'Intervallo Richieste', class: 'text-center'},
                {key: 'requests', label: 'Richieste', class: 'text-center'},
                {key: 'action', label: ''},
            ],
            statusOptions: [
                {name: 'chiuse', value: 'closed'},
                {name: 'aperte', value: 'progress'},
                {name: 'future', value: 'incoming'},
            ],
        }
    },
    mounted() {

    },
    methods: {
        matchLogo: function (competition) {
            return MatchService.getCompetitionLogo(competition)

        },
        getStatusQuantity: function (items, status) {
            return _.filter(items, (item) => {
                return item.status === status;
            }).length;
        },
    }
}
</script>

<style scoped>

</style>
